import { render, staticRenderFns } from "./Ledenopbouw.vue?vue&type=template&id=9fe6ea90&scoped=true&"
import script from "./Ledenopbouw.vue?vue&type=script&lang=js&"
export * from "./Ledenopbouw.vue?vue&type=script&lang=js&"
import style0 from "./Ledenopbouw.vue?vue&type=style&index=0&id=9fe6ea90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe6ea90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
